import Vue from 'vue'
import mitt from 'mitt'

Vue.prototype.$mitt = mitt()
